import * as React from "react";
function SvgRoundArrowCross(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
      >
        <path d="M4.5 16A11.5 11.5 0 1016 4.5H4.5" />
        <path d="M6.75 1.5l-3 3 3 3m6 5.25l6.5 6.5m0-6.5l-6.5 6.5" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgRoundArrowCross);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
